import { defineComponent as c, ref as f, onMounted as h, nextTick as b, computed as g, withDirectives as v, createElementBlock as w, openBlock as x, mergeProps as y, withKeys as s, vModelText as k } from "vue";
const D = ["placeholder"], V = /* @__PURE__ */ c({
  inheritAttrs: !1,
  __name: "CommandActionInput",
  props: {
    modelValue: {},
    placeholder: {},
    autofocus: { type: Boolean }
  },
  emits: ["update:modelValue", "onDelete"],
  setup(i, { emit: p }) {
    const n = i, r = p, a = f(null);
    h(
      () => b(() => {
        var e;
        n.autofocus || (e = a.value) == null || e.focus();
      })
    );
    const l = g({
      get: () => n.modelValue ?? "",
      set: (e) => r("update:modelValue", e)
    });
    function d(e) {
      var u;
      if (e.shiftKey || !e.target)
        return;
      e.preventDefault();
      const t = e.target, o = new Event("submit", { cancelable: !0 });
      (u = t.form) == null || u.dispatchEvent(o);
    }
    function m(e) {
      l.value === "" && (e.preventDefault(), e.stopPropagation(), r("onDelete", e));
    }
    return (e, t) => v((x(), w("textarea", y({
      id: "command-action-input",
      ref_key: "input",
      ref: a,
      "onUpdate:modelValue": t[0] || (t[0] = (o) => l.value = o),
      class: "min-h-8 w-full flex-1 resize-none border border-transparent py-1.5 pl-8.5 text-sm outline-none focus:border-b-1",
      placeholder: n.placeholder ?? "",
      wrap: "hard"
    }, e.$attrs, {
      onKeydown: [
        t[1] || (t[1] = s((o) => m(o), ["delete"])),
        t[2] || (t[2] = s((o) => d(o), ["enter"]))
      ]
    }), null, 16, D)), [
      [k, l.value]
    ]);
  }
});
export {
  V as default
};
